/**
 * STORE VAINILLA
 */
import axios from "axios";
import config from "../../assets/config";
import cookie from "../modules/cookie";

const app = config.APP;

const state = () => ({
  proyecto_v: null,
  url_logo: null,
  SUBSTATES: null,
  SUBSTATES_CONFIG: null
});

const mutations = {
  resetProyectoV(state) {
    state.proyecto_v = {
      codetitle: app.TITLE,
      description: app.DESCRIPTION,
      primary: app.COLORS.primary,
      secondary: app.COLORS.secondary,
      accent: app.COLORS.accent,
      text: app.COLORS.text,
      env: true,
      favicon: app.FAVICON,
    };
    state.url_logo = require(`~/static/images/${app.LOGO}`);
    state.SUBSTATES = null;
    state.SUBSTATES_CONFIG = null;
  },
  setProyectoV(state, item) {
    state.proyecto_v = item;
  },
  setUrlLogo(state, item) {
    state.url_logo = item;
  },
  setSubstates(state, item) {
    state.SUBSTATES = item
  },
  setSubstatesConfig(state, item) {
    state.SUBSTATES_CONFIG = item
  }
};

const getters = {
  proyecto_v: (state) => {
    if (config.APP.PROYECTO_VAINILLA == true && state.proyecto_v) {
      return state.proyecto_v;
    } else {
      state.proyecto_v = {
        codetitle: app.TITLE,
        description: app.DESCRIPTION,
        primary: app.COLORS.primary,
        secondary: app.COLORS.secondary,
        accent: app.COLORS.accent,
        text: app.COLORS.text,
        env: true,
        favicon: app.FAVICON,
      };
      return state.proyecto_v;
    }
  },
  url_logo: (state) => {
    if (config.APP.PROYECTO_VAINILLA == true && state.url_logo) {
      return state.url_logo;
    } else {
      let url = require(`~/static/images/${app.LOGO}`);
      state.url_logo = url;
      return state.url_logo;
    }
  },
  substates: (state) => {
    if (config.APP.PROYECTO_VAINILLA == true && state.SUBSTATES) {
      return state.SUBSTATES
    } else {
      let substates = app.substates
      state.SUBSTATES = substates
      return state.SUBSTATES
    }
  },
  substates_config: (state) => {
    if (config.APP.PROYECTO_VAINILLA == true && state.SUBSTATES_CONFIG) {
      return state.SUBSTATES_CONFIG
    } else {
      let substates_config = app.substates_config
      state.SUBSTATES_CONFIG = substates_config
      return state.SUBSTATES_CONFIG
    }
  }
};

const actions = {
  async loadPV({ commit }, id) {
    try {
      if (config.APP.PROYECTO_VAINILLA == true) {
        let { data } = await axios.get(`${config.api_url}proyectos/web_config/${id}`);
        if (data.success) {
          if(data.info['WEB_CONFIG']){
            let proyecto = data.info['WEB_CONFIG'];
            proyecto.codenumber = data.info.docnumber
            proyecto.entity_uid = data.info.docid
            proyecto.logo = data.info.logo
            commit("setProyectoV", proyecto);
            // Host desde la configuración del ambiente y cache-buster para
            // que el navegador no muestre el logo de una sesión anterior.
            let urlLogo =
              `${config.api_no_proxy.archivos}${proyecto.codenumber}/public/logo.png?t=${Date.now()}`;
            commit("setUrlLogo", urlLogo);
            commit("setSubstates", proyecto.SUBSTATES)
            commit("setSubstatesConfig", proyecto.SUBSTATES_CONFIG)
          } else {
            let proyecto = data.info[0].doc;
            proyecto.codenumber = data.info[0].docnumber
            proyecto.entity_uid = data.info[0].docid
            commit("setProyectoV", proyecto);
          }
         
        } else {
          this.$router.push(config.router.login);
        }
      } else {
        commit("setProyectoV", config.APP);
      }
    } catch (error) {
      console.error(error);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
